import React from "react";

const Maybe = ({ test, children }:{test:any, children:any}) => <>{test && children}</>;

export default Maybe;
